import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';
import { b as bem } from './p-c44c2366.js';
import { d as defineCustomElement$1 } from './p-db87170c.js';

const cosmosSelectValueCss = ":host{display:block;height:100%;max-width:100%;position:relative}:host([multiple]){display:inline}.cosmos-select-value{--cosmos-text-color:currentColor;-ms-flex-align:center;align-items:center;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;display:-ms-inline-flexbox;display:inline-flex;margin:0;max-width:100%;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.cosmos-select-value--multiple{display:inline}.cosmos-select-value--multiple ::slotted([slot=prefix]){display:inline-block;margin-bottom:2px;vertical-align:middle}.cosmos-select-value__label{overflow:hidden}.cosmos-select-value--multiple .cosmos-select-value__label{display:inline}.cosmos-select-value ::slotted([slot=prefix]){-ms-flex:0 0 auto;flex:0 0 auto;-webkit-margin-end:var(--cosmos-select-gap, 6px);margin-inline-end:var(--cosmos-select-gap, 6px);--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";
const CosmosSelectValueStyle0 = cosmosSelectValueCss;

const generateClassNames = bem('cosmos-select-value');
const CosmosSelectValue = /*@__PURE__*/ proxyCustomElement(class CosmosSelectValue extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleSlotChange = (event) => {
            var _a, _b, _c, _d, _e;
            const slot = event.target;
            const nodes = slot.assignedNodes();
            if (this.multiple) {
                nodes.forEach((node) => {
                    var _a, _b;
                    if (node.nodeType === Node.TEXT_NODE) {
                        node.textContent = (_b = (_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : ''; // Trim the inline text
                    }
                });
            }
            else {
                this.title = (_c = (_b = (_a = nodes[0].parentElement) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : '';
                this.meta = (_e = (_d = nodes[0].parentElement) === null || _d === void 0 ? void 0 : _d.getAttribute('meta')) !== null && _e !== void 0 ? _e : '';
            }
        };
        this.multiple = false;
        this.meta = '';
        this.title = '';
    }
    composeTitle() {
        if (this.meta) {
            return `${this.title} • ${this.meta}`;
        }
        return this.title;
    }
    render() {
        return (h(Host, { key: '714226ee5ba1e716a643ba356483b70254238c93' }, h("div", { key: '3ad895341fc7c7899b1e5712239ccd55bc5f552f', title: this.composeTitle(), class: generateClassNames({ multiple: this.multiple }), part: "base" }, h("slot", { key: '3a8300a17d1857dd819bc2e464a89d34af28c6fe', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: 'd1afda96d164d5c319e3261c59661e023b1e4351', clamp: 1, class: generateClassNames('label'), exportparts: "base: label", size: "small", tag: this.multiple ? 'span' : 'p' }, h("span", { key: '9b0905c3caf4c9e600ad087923ebb1a457de0f63' }, h("slot", { key: '8c9bcc48a190bf5ade0792f4bfc7537a3ae9f649', onSlotchange: this.handleSlotChange }))))));
    }
    get element() { return this; }
    static get style() { return CosmosSelectValueStyle0; }
}, [1, "cosmos-select-value", {
        "multiple": [516],
        "meta": [32],
        "title": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-select-value", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-select-value":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosSelectValue);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { CosmosSelectValue as C, defineCustomElement as d };
